"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function useStateEffects(initialState) {
    var _a = React.useState({
        state: initialState,
        effects: []
    }), _b = _a[0], state = _b.state, effects = _b.effects, setState = _a[1];
    var setState$ = React.useCallback(function (update) { return setState(function (_a) {
        var state = _a.state, effects = _a.effects;
        var _b = update(state), state$ = _b[0], pendingEffects = _b.slice(1);
        var effects$ = pendingEffects.filter(function (effect) { return effect && typeof effect === 'function'; });
        return {
            state: state$,
            effects: effects$ ? effects.concat(effects$) : effects,
        };
    }); }, []);
    React.useEffect(function () {
        if (effects.length > 0) {
            // Delay needed in order to ensure that executed after refs being set
            setTimeout(function () {
                effects.forEach(function (fx) { return fx(); });
            });
            setState(function (state) { return (__assign({}, state, { effects: [] })); });
        }
    }, [effects]);
    return [
        state,
        setState$,
    ];
}
exports.default = useStateEffects;
